// extracted by mini-css-extract-plugin
export default {"paddingLeft":"CountdownContainer_paddingLeft__I8AHI","countDownText":"CountdownContainer_countDownText__-hmdN","modalActions":"CountdownContainer_modalActions__+qjN9"};